import PropTypes from 'prop-types';

import AcceptButton from '../ButtonsApprovalPending/AcceptButton/AcceptButton';
import RejectButton from '../ButtonsApprovalPending/RejectButton/RejectButton';
import AlertWorkReportApproverButton from '../ButtonsApprovalPending/AlertWorkReportApproverButton/AlertWorkReportApproverButton';
import CommentsWorkReportApproverButton from '../ButtonsApprovalPending/CommentsWorkReportApproverButton/CommentsWorkReportApproverButton';
import ViewSdsDetails from '../ButtonsApprovalPending/ViewSdsDetails/ViewSdsDetails';
import FilesWorkReportApproverButton from '../ButtonsApprovalPending/FilesWorkReportApproverButton/FilesWorkReportApproverButton';
import EditButton from '../../../ApprovalSend/ButtonApprovalSend/EditButton';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../utils/globalPropTypes';
import ModifyImputation from '../ButtonsApprovalPending/ModifyImputation/ModifyImputation';
import ExpertReview from '../ButtonsApprovalPending/ExpertReview/ExpertReview';
import { optimisticInitialState } from '../../../WeeklyReportTable/reducer/optimisticUIReducer';
import ProgramPointButton from '../ButtonsApprovalPending/ProgramPointButton/ProgramPointButton';
import CodButton from '../ButtonsApprovalPending/CodButton/CodButton';

const ActionButtonApproval = ({
  changedActions,
  dailyWorkReport,
  fetchData,
  handleChangedActions,
  selectedDate,
  visibleAccept,
  visibleComment,
  visibleEdit,
  visibleExpertReview,
  visibleFiles,
  visibleLink,
  visibleModifyImputation,
  visibleReject,
  visibleReview,
  visiblePP,
  isExtentedView
}) => (
  <div className="d-flex align-items-center justify-content-center">
    {visibleLink && (
      <ViewSdsDetails
        idSolicitud={dailyWorkReport.idSolicitud}
        tipoAsignacion={dailyWorkReport.tipoAsignacion}
      />
    )}
    {visibleModifyImputation && (
      <ModifyImputation
        changedActions={changedActions}
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
    {/* NO lo ve la vista extendida */}
    {visibleAccept && (
      <AcceptButton
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        selectedDate={selectedDate}
      />
    )}

    {/* SI lo ve la vista extendida */}
    {visibleReject && (
      <RejectButton
        dailyWorkReport={{ ...dailyWorkReport, isExtentedView }}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
    {/* SI lo ve la vista extendida */}

    {visibleEdit && (
      <EditButton
        dailyWorkReport={{ ...dailyWorkReport, isExtentedView }}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
    {/* NO lo ve la vista extendida */}

    {visiblePP && (
      <ProgramPointButton
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
    {/* NO lo ve la vista extendida */}
    {visiblePP && (
      <CodButton
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
    {!!visibleExpertReview && (
      <ExpertReview
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        selectedDate={selectedDate}
      />
    )}
    {!!visibleFiles && (
      <FilesWorkReportApproverButton
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        selectedDate={selectedDate}
      />
    )}
    {!!visibleComment && (
      <CommentsWorkReportApproverButton
        dailyWorkReport={dailyWorkReport}
        selectedDate={selectedDate}
      />
    )}
    {visibleReview && (
      <AlertWorkReportApproverButton
        dailyWorkReport={dailyWorkReport}
        fetchData={fetchData}
        handleChangedActions={handleChangedActions}
        selectedDate={selectedDate}
      />
    )}
  </div>
);

ActionButtonApproval.propTypes = {
  changedActions: PropTypes.shape({}),
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  handleChangedActions: PropTypes.func,
  selectedDate: PropTypes.string,
  visibleAccept: PropTypes.bool,
  visibleComment: PropTypes.bool,
  visibleEdit: PropTypes.bool,
  visibleExpertReview: PropTypes.bool,
  visibleFiles: PropTypes.bool,
  visibleLink: PropTypes.bool,
  visibleModifyImputation: PropTypes.bool,
  visibleReject: PropTypes.bool,
  visibleReview: PropTypes.bool,
  visiblePP: PropTypes.bool,
  isExtentedView: PropTypes.bool
};

ActionButtonApproval.defaultProps = {
  changedActions: optimisticInitialState,
  dailyWorkReport: {},
  fetchData: () => {},
  handleChangedActions: () => {},
  selectedDate: '',
  visibleAccept: true,
  visibleComment: true,
  visibleEdit: true,
  visibleExpertReview: false,
  visibleFiles: true,
  visibleLink: false,
  visibleModifyImputation: false,
  visibleReject: true,
  visibleReview: true,
  visiblePP: false,
  isExtentedView: false
};

export default ActionButtonApproval;
